import styles from "./ErrorScreen.module.css";

function ErrorScreen() {
  return (
    <div className={styles.appContainer}>
      <main className={styles.errorContainer}>
        <i className={`${"narmi-icon-alert-triangle"} ${styles.errorIcon}`} />
        <p className="fontSize--heading3 fontWeight--semibold">We&apos;re sorry</p>
        <p className="margin--top--s">
          An unexpected error has occurred. We apologize for the inconvenience.
        </p>
      </main>
    </div>
  );
}

export { ErrorScreen };
